angular.module('tgaApp').directive('onLastTriggerResize', ['$timeout', '$rootScope',
  function ($timeout, $rootScope) {
    return {
      link: (scope) => {
        if (scope.$last) {
          $timeout(() => {
            $rootScope.$broadcast('resize-text');
          });
        }
      },
    };
  },
]);
